import { render } from "./settings.svg?vue&type=template&id=4be5feea"
const script = {}
script.render = render

export default script